import React, { useEffect } from "react";
import { useRecoilValue } from "recoil";
import SwapComponent from "../../components/swap/SwapComponent/SwapComponent";
import { themeState } from "../../context/themeState";

import "../pages.css";

const Swap = () => {
  const root = document.querySelector(':root');
  const theme = useRecoilValue(themeState);
  useEffect(()=>{

    if(theme === "Light"){
      root?.classList.add('lighttheme')
    }
  },[])
  return (
    <div className="component-page swap-component-page">
      <SwapComponent />
    </div>
  );
};

export default Swap;
